import { useOutletContext } from 'react-router-dom';

import { isUndefined } from 'lodash';

import { snakeToTitleCase } from 'lib/helpers/utility';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Switch from 'components/shared/Switch/Switch';

import TransactionBatchTime from './components/TransactionBatchTime';

const FormsSettings = () => {
  const { defaultPracticeSettings, practice, handleChange, updateDisabled } = useOutletContext();

  return (
    <div className="overflow-auto !pr-1">
      <p className="pb-1 text-lg font-600 text-neutral-700">Forms</p>
      <div className="grid grid-cols-2 gap-4">
        {practice?.display_settings &&
          Object.keys({ ...defaultPracticeSettings, ...practice?.display_settings }).map(
            (v, key) => {
              if (
                typeof practice?.display_settings[v] === 'boolean' ||
                Object.keys(defaultPracticeSettings).includes(v)
              ) {
                return (
                  <div
                    className="flex flex-col gap-2 rounded-md border border-solid border-neutral-200 !p-3"
                    key={key}>
                    <div>{snakeToTitleCase(v)}</div>
                    <Switch
                      onChange={() =>
                        handleChange(
                          v,
                          isUndefined(practice?.display_settings[v])
                            ? !defaultPracticeSettings[v]
                            : !practice?.display_settings[v]
                        )
                      }
                      checked={
                        isUndefined(practice?.display_settings[v])
                          ? defaultPracticeSettings[v]
                          : practice?.display_settings[v]
                      }
                      disabled={updateDisabled}
                    />
                  </div>
                );
              }
            }
          )}
        <div className="flex flex-col gap-2 rounded-md border border-solid border-neutral-200 !p-3">
          <div>Technology fee</div>
          <div>
            <Switch
              onChange={(e) => handleChange({ name: 'surcharge', state: e })}
              checked={practice?.surcharge}
              disabled={updateDisabled}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 rounded-md border border-solid border-neutral-200 !p-3">
          <div>Outside Financing</div>
          <div>
            <Switch
              onChange={(e) => handleChange({ name: 'care_credit', state: e })}
              checked={practice?.care_credit}
              disabled={updateDisabled}
            />
          </div>
        </div>

        <div className="flex flex-col gap-2 rounded-md border border-solid border-neutral-200 !p-3">
          <div>Transaction batch time</div>
          <TransactionBatchTime
            debounceTime={1000}
            practice={practice}
            updatePractice={(practice) => {
              handleChange('billing', practice.display_settings?.billing);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(FormsSettings);
